export default __webpack_public_path__ + "static/tipologie-app-in-node-js-80bcbde26a40df767f349d84d1bf9dc9.png";